
export type LikeTweet200 = {
  likeCount?: number;
  success?: boolean;
};
